var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"no_car_list"},[_c('img',{staticClass:"no_car_icon",attrs:{"src":require("../../stylesheets/images/icon/no-vehicwle-icon.jpg")}}),_c('p',{staticClass:"tips"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }